import React, { useState, useEffect } from "react";
import { Box, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

import Sidebar from "./MobileSidebar";
import Navbar from "./MobileNavbarComponets/MobileNavbar";

const Layout = ({ children }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // ✅ مغلق افتراضياً على الموبايل
  const [orientation, setOrientation] = useState("portrait");

  const theme = useTheme();
  // ✅ كشف أفضل للأجهزة المحمولة (حتى 900px)
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down("sm")); // أصغر من 600px
  const isLandscape = useMediaQuery("(orientation: landscape)");

  // ✅ تتبع تغيير الاتجاه
  useEffect(() => {
    setOrientation(isLandscape ? "landscape" : "portrait");
    // إغلاق Sidebar تلقائياً عند تدوير الشاشة في landscape
    if (isLandscape && isMobile) {
      setIsSidebarOpen(false);
    }
  }, [isLandscape, isMobile]);

  // ✅ منع scroll عند فتح Sidebar
  useEffect(() => {
    if (isSidebarOpen && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isSidebarOpen, isMobile]);

  // ✅ إذا لم يكن موبايل، أرجع children بدون Layout
  if (!isMobile) {
    return children;
  }

  const sidebarWidth = isSidebarOpen ? (isSmallMobile ? "280px" : "300px") : "0px";

  return (
    <Box
      sx={{
        display: "flex",
        direction: "rtl",
        minHeight: "100vh",
        minHeight: "100dvh", // ✅ استخدام dvh للـ dynamic viewport (iPhone)
        position: "relative",
        overflow: "hidden",
        // ✅ Safe Area للـ iPhone
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
        paddingLeft: "env(safe-area-inset-left)",
        paddingRight: "env(safe-area-inset-right)",
      }}
    >
      {/* ✅ Overlay عند فتح Sidebar */}
      {!isLoginPage && isSidebarOpen && (
        <Box
          onClick={() => setIsSidebarOpen(false)}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1199,
            transition: "opacity 0.3s ease-in-out",
          }}
        />
      )}

      {!isLoginPage && (
        <Sidebar
          isOpen={isSidebarOpen}
          toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          isMobile={isMobile}
          isSmallMobile={isSmallMobile}
        />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          minHeight: "100vh",
          minHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
          transition: "none", // ✅ إزالة transition للـ performance
          position: "relative",
          // ✅ تعديل margin حسب حالة الـ Sidebar
          marginRight: 0,
          // ✅ تحسين للـ landscape mode
          ...(orientation === "landscape" && {
            maxHeight: "100dvh",
            overflowY: "auto",
          }),
        }}
      >
        {!isLoginPage && (
          <Navbar
            isSidebarOpen={isSidebarOpen}
            toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
            isMobile={isMobile}
          />
        )}
        {!isLoginPage && <Toolbar sx={{ minHeight: { xs: 56, sm: 64 } }} />}
        
        <Box
          sx={{
            flex: 1,
            width: "100%",
            overflowX: "hidden",
            overflowY: "auto",
            // ✅ Padding آمن للمحتوى
            px: { xs: 2, sm: 3 },
            py: { xs: 2, sm: 3 },
            // ✅ تحسين للـ scroll behavior
            WebkitOverflowScrolling: "touch",
            // ✅ تجنب المشاكل مع الـ keyboard على الموبايل
            position: "relative",
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
